import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { PageHeader, StatusBadge } from "../components/PageHeader";
import { DataTable } from "../components/DataTable";
import { Loader } from "../components/KpiCard";
import { Modal, Field, TextInput, SelectInput, AddButton } from "../components/Form";

const TYPES = ["Asset", "Liability", "Net Assets", "Revenue", "Expense"];

export default function ChartOfAccounts() {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({ account_number: "", account_name: "", account_type: "Asset", account_category: "", normal_balance: "Debit" });

  const load = () => api.get("/accounts").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/accounts", form);
      toast.success("Account created");
      setOpen(false);
      setForm({ account_number: "", account_name: "", account_type: "Asset", account_category: "", normal_balance: "Debit" });
      load();
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  if (!rows) return <Loader />;

  const columns = [
    { key: "account_number", label: "Number", className: "font-mono text-[#1A1A1A]" },
    { key: "account_name", label: "Account Name" },
    { key: "account_type", label: "Type", render: (r) => <StatusBadge tone="blue">{r.account_type}</StatusBadge> },
    { key: "account_category", label: "Category", className: "text-[#5C5C54]" },
    { key: "normal_balance", label: "Normal Balance", className: "text-[#5C5C54]" },
    { key: "financial_statement", label: "Statement", className: "text-[#5C5C54] text-xs" },
  ];

  return (
    <div>
      <PageHeader title="Chart of Accounts" subtitle="The financial classification foundation for all transactions."
        action={<AddButton onClick={() => setOpen(true)} label="New Account" testid="add-account-btn" />} />
      <DataTable columns={columns} rows={rows} testid="accounts-table" empty={{ title: "No accounts", hint: "Add your first account." }} />

      <Modal open={open} onOpenChange={setOpen} title="New Account" onSubmit={submit} busy={busy} testid="account-modal">
        <Field label="Account Number"><TextInput required value={form.account_number} onChange={(e) => setForm({ ...form, account_number: e.target.value })} placeholder="6010" /></Field>
        <Field label="Normal Balance"><SelectInput value={form.normal_balance} onChange={(e) => setForm({ ...form, normal_balance: e.target.value })} options={["Debit", "Credit"]} /></Field>
        <Field label="Account Name" span={2}><TextInput required value={form.account_name} onChange={(e) => setForm({ ...form, account_name: e.target.value })} /></Field>
        <Field label="Type"><SelectInput value={form.account_type} onChange={(e) => setForm({ ...form, account_type: e.target.value })} options={TYPES} /></Field>
        <Field label="Category"><TextInput value={form.account_category} onChange={(e) => setForm({ ...form, account_category: e.target.value })} /></Field>
      </Modal>
    </div>
  );
}
